<template>
  <div style="" class="scroll-box" ref="scrollbox">
    <bannaerCom />
    <div id="aboutUs">
      <aboutUsCom />
      <organizationCom />
      <businessCom />
      <swiperImgListCom />
    </div>
    <journalCom />

    <memberCom />
    <activityCom />
    <MembershipstyleCom />
    <JoinUsCom />
  </div>
</template>
<script>
import bannaerCom from "./components/banner";
import aboutUsCom from "./components/aboutUs";
import organizationCom from "./components/organization";
import businessCom from "./components/business.vue";
import swiperImgListCom from "./components/swiperImgList.vue";
import journalCom from "./components/Journal.vue";
import memberCom from "./components/member.vue";
import activityCom from "./components/activity.vue";
import MembershipstyleCom from "./components/membershipStyle.vue";
import JoinUsCom from "./components/JoinUs.vue";
export default {
  components: {
    bannaerCom,
    aboutUsCom,
    organizationCom,
    businessCom,
    swiperImgListCom,
    journalCom,
    memberCom,
    activityCom,
    MembershipstyleCom,
    JoinUsCom,
  },
  data: () => {
    return {
      scrollTop: 0,
    };
  },

  // 组件激活时触发
  activated() {
    // 还原滚动条位置
    // console.log("1212-activated");
    //  console.log("this.scrollTop", this.scrollTop);
    // // document.getElementsByClassName("scroll-box")[0].scrollTop =this.scrollTop || 0; //组件写法
    // document.getElementById("app").scrollTop = this.scrollTop || 0; //全局写法
  },
};
</script>

<style lang="less" scoped>
div {
  background: #f9f9f9;
  // justify-content: space-between;
}

.hid-scroll-bar {
}
</style>